import { render, staticRenderFns } from "./DataCollectionDetailPanel.vue?vue&type=template&id=51a80948&scoped=true"
import script from "./DataCollectionDetailPanel.vue?vue&type=script&lang=js"
export * from "./DataCollectionDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./DataCollectionDetailPanel.vue?vue&type=style&index=0&id=51a80948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a80948",
  null
  
)

export default component.exports